module.exports = __webpack_public_path__ + "img/bs.8d18709d.svg";